import App from '@app/app';
import { Breakpoint } from '@app/utils/breakpoint';
import { computed, DestroyRef, inject, Injectable, signal } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import { WINDOW } from '@app/core/window.token';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly window = inject(WINDOW);

  public readonly innerWidth = signal(this.window?.innerWidth ?? 0);

  public readonly isMobile = computed(() => this.innerWidth() < Breakpoint.MEDIUM);
  public readonly isDesktop = computed(() => !this.isMobile());

  constructor() {
    if (typeof this.window === 'undefined') return;

    const window = this.window;

    const onResize = () => this.innerWidth.set(window.innerWidth);

    window.addEventListener('resize', onResize);

    this.destroyRef.onDestroy(() => {
      window.removeEventListener('resize', onResize);
    });
  }
}

App.factory('DeviceService', downgradeInjectable(DeviceService));
